import { config } from '@config';
import {
  faceCaptureErrorMessageSchema,
  faceCaptureSuccessMessageSchema,
} from '../schemas';

/**
 * One-way child → parent messaging per the ESS integration spec. ESS never
 * posts into this iframe; after a success message this page's job is done
 * (ESS closes the dialog or reloads the iframe in verify mode).
 */
export function postCaptureSuccess(imageBase64: string): void {
  const message = faceCaptureSuccessMessageSchema.parse({
    type: 'face-capture:success',
    image_base64: imageBase64,
  });
  window.parent.postMessage(message, config.parentOrigin);
}

export function postCaptureError(message: string): void {
  const payload = faceCaptureErrorMessageSchema.parse({
    type: 'face-capture:error',
    message,
  });
  window.parent.postMessage(payload, config.parentOrigin);
}
